var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justifty-content-sm-center center"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"6x","spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }